import React, { Component } from 'react';
//import logo from './logo.svg';

import { Route, Switch } from 'react-router-dom';
import { BrowserRouter as Router } from 'react-router-dom';

import AppliedRoute from './components/AppliedRoute';
import Home from './containers/Home'
import NotFound from './containers/NotFound'
import Signup from './containers/Signup'

import './App.css';

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }
  render() {

    const childProps = {
    };

    return (
      <div className="App"  id="page-top">
          <this.NavBar/>
          <Router>
            <Switch>
              <AppliedRoute path="/" exact component={Home} props={childProps} />
              <AppliedRoute path="/signup-invited" exact component={Signup} props={childProps} />
              {
                // { /* Finally, catch all unmatched routes */ }
                <Route component={NotFound} />
              }
            </Switch>
          </Router>
          <this.Footer/>
      </div>
    );
  }

  NavBar() {
    return  (
        <nav id="mainNav" className="navbar navbar-default navbar-custom navbar-fixed-top">
            <div className="container">
                <div className="navbar-header page-scroll">

                    <button type="button" className="navbar-toggle"
                      data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
                        <span className="sr-only">Toggle navigation</span>
                         <i className="fa fa-bars"></i>
                    </button>
                    <a className="navbar-brand js-scroll-trigger" href="/#page-top" style={{
                        fontSize: 24,
                    }}>Retail Knack</a>
                </div>

                <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
                    <ul className="nav navbar-nav navbar-right">
                        
                        <li>
                            <a className="page-scroll" href="/#scenarios"
                              data-toggle="collapse" data-target=".navbar-collapse" >
                              Who we serve
                            </a>
                        </li>
                        <li>
                            <a className="page-scroll" href="/#products"
                              data-toggle="collapse" data-target=".navbar-collapse">
                              Our Products
                            </a>
                        </li>
                        <li>
                            <a className="page-scroll" href="/#contact"
                              data-toggle="collapse" data-target=".navbar-collapse" >
                              Free Trial
                            </a>
                        </li>
                        <li>
                            <a className="page-scroll" href="/#about"
                              data-toggle="collapse" data-target=".navbar-collapse" >
                              About Us
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
      )
  }

  Footer() {
    return (
      <footer>
          <div className="container">
              <div className="row">
                  <div className="col-md-4"/>
                  <div className="col-md-4">
                      <span className="copyright">Copyright &copy; YaDing-Soft 2017</span>
                  </div>
                  <div className="col-md-4"/>
                  {
                    // <div className="col-md-4">
                    //     <ul className="list-inline social-buttons">
                    //         <li><a href="#"><i className="fa fa-twitter"></i></a>
                    //         </li>
                    //         <li><a href="#"><i className="fa fa-facebook"></i></a>
                    //         </li>
                    //         <li><a href="#"><i className="fa fa-linkedin"></i></a>
                    //         </li>
                    //     </ul>
                    // </div>
                    // <div className="col-md-4">
                    //     <ul className="list-inline quicklinks">
                    //         <li><a href="#">Privacy Policy</a>
                    //         </li>
                    //         <li><a href="#">Terms of Use</a>
                    //         </li>
                    //     </ul>
                    // </div>
                  }
              </div>
          </div>
      </footer>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js